var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal"
  }, [_c('span', {
    staticClass: "modal__trigger",
    on: {
      "click": function($event) {
        _vm.toggleModal()
      }
    }
  }, [_vm._t("trigger")], 2), _vm._v(" "), (_vm.modalShowing) ? _c('div', {
    staticClass: "modal__overlay"
  }, [_c('a', {
    staticClass: "cm-button modal__trigger modal__trigger--inner",
    on: {
      "click": function($event) {
        _vm.toggleModal()
      }
    }
  }, [_c('i', {
    staticClass: "ss-icon"
  }, [_vm._v("close")])]), _vm._v(" "), _c('div', {
    staticClass: "modal__content"
  }, [_c('div', {
    staticClass: "modal__inner-content"
  }, [_vm._t("content")], 2)])]) : _vm._e()])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2acf23c5","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/components/modal.vue
// module id = null
// module chunks = 